
const init = () => {
    const projectItems = document.querySelectorAll('.project-item');

    if (projectItems.length === 0) return;

    // Observer for mobile autoplay
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
    };

    const observer = new IntersectionObserver((entries) => {
        if (window.innerWidth < 767) {
            entries.forEach(entry => {
                const video = entry.target;
                if (entry.isIntersecting) {
                    const playPromise = video.play();
                    if (playPromise !== undefined) {
                        playPromise.catch(error => {
                            console.log("Autoplay prevented by browser policy", error);
                        });
                    }
                } else {
                    video.pause();
                }
            });
        } else {
            // Ensure videos are paused if we switch to desktop view while they were playing via observer
            // Or rely on hover. 
            // Actually, if we resize from mobile to desktop, the running video might keep running.
            // But 'hover' logic expects it to be paused unless hovered.
            // Let's leave it simple for now. 
        }
    }, observerOptions);

    projectItems.forEach(item => {
        const video = item.querySelector('.project-item__video video');
        if (!video) return;

        // 1. Mobile Autoplay Setup
        observer.observe(video);

        // 2. Desktop Hover Setup
        item.addEventListener('mouseenter', () => {
            if (window.innerWidth >= 767) {
                const playPromise = video.play();
                if (playPromise !== undefined) {
                    playPromise.catch(error => {
                        console.log("Hover play prevented", error);
                    });
                }
            }
        });

        item.addEventListener('mouseleave', () => {
            if (window.innerWidth >= 767) {
                video.pause();
            }
        });
    });
};

export { init };
